export enum NgrxStoreKeys {
    ACTIVITY_FEATURE_KEY = 'activities',
    SEARCH_FEATURE_KEY = 'search',
    PRODUCT_CATEGORY_FEATURE_KEY = 'productCategories',
    APPOINTMENT_METADATA_FEATURE_KEY = 'appointmentMetadata',

    APPOINTMENT_DATES_FEATURE_KEY = 'appointmentDates',
    APPOINTMENT_DETAILS_FEATURE_KEY = 'appointmentDetails',
    APPOINTMENT_CONTACT_INFO_FEATURE_KEY = 'appointmentContactInfo',

    OFFER_CONTACT_INFORMATION_FEATURE_KEY = 'offerContactInfo',
}
